import { render, staticRenderFns } from "./FarabiCoaIDCard.vue?vue&type=template&id=f627043e&scoped=true&"
import script from "./FarabiCoaIDCard.vue?vue&type=script&lang=js&"
export * from "./FarabiCoaIDCard.vue?vue&type=script&lang=js&"
import style0 from "./FarabiCoaIDCard.vue?vue&type=style&index=0&id=f627043e&lang=scss&scoped=true&"
import style1 from "./FarabiCoaIDCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f627043e",
  null
  
)

export default component.exports